import React from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import "./MortgageRenewal.css";

const MortgageRenewal = () => {
  const [contentRef, contentVisible] = useScrollAnimation();

  return (
    <section className="mortgage-renewal">
      <div className="mortgage-renewal-container">
        <div ref={contentRef} className={`mortgage-renewal-content ${contentVisible ? "animate-in" : ""}`}>
          <div className="mortgage-renewal-text">
            <h2 className="mortgage-renewal-title">Renewing Your Mortgage This Year?</h2>
            <p className="mortgage-renewal-description">
              Mortgage renewal is a natural opportunity to reassess not only interest rates, but also how your mortgage is protected. Many homeowners carry lender-based mortgage insurance that has never been reviewed.
            </p>
            <p className="mortgage-renewal-description">
              A short review can help determine whether your current protection still aligns with your needs, goals, and financial reality.
            </p>
            <button className="mortgage-renewal-cta">
              Request a Mortgage Protection Review
              <span className="arrow-icon">→</span>
            </button>
          </div>
          <div className="mortgage-renewal-image">
            <img 
              src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&h=400&fit=crop" 
              alt="Mortgage documents and keys" 
              className="mortgage-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MortgageRenewal;
